import React, { useCallback } from 'react';

import { createLocale } from 'locales';

import { useAvailableSingleCallJobs } from 'state/context/freelancer/FreelancerAvailableJobs';

import Button from 'components/button/button';

import JobList from './components/JobList/JobList';

import Filters from './components/Filters/Filters';

import Heading from './components/heading/Heading';

import FreelancerNavBar from './components/navigationBar/FreelancerNavBar';

import FreelacerFooter from './components/footer/FreelancerFooter';

// import Message from './components/message/message';

const localize = createLocale('freelancerAvailableJobsLocales');

const FreelancerAvailableJobs: React.FC = () => {
  const { availablejobs, setKindOfJob, handleFilterEnabled } =
    useAvailableSingleCallJobs();
  const displayMessage = availablejobs && availablejobs.personalInvitesNumber;
  const text = localize('personalJobsNotification', {
    count: availablejobs.personalInvitesNumber,
  });
  const getPersonalJobs = useCallback(() => {
    setKindOfJob('personal');
    handleFilterEnabled(true);
  }, [handleFilterEnabled, setKindOfJob]);

  return (
    <div className="flex items-center flex-col justify-center w-full">
      <FreelancerNavBar />
      {!!displayMessage && (
        <Button
          variant="transparent"
          type="button"
          label={text}
          onClick={getPersonalJobs}
          className="mt-6 container flex flex-col justify-start w-full mb-9 px-3 md:px-0"
        />
      )}

      <Heading
        leftBtnActive={false}
        title={localize('singleCalls')}
        containerClassName={displayMessage ? 'mt-0' : 'mt-4 md:mt-10'}
      />
      <Filters />
      <JobList />
      <FreelacerFooter />
    </div>
  );
};

export default FreelancerAvailableJobs;
